<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <p>
            <b>{{ $t('modals.finishedTaskDocument.idCaseName') }}:</b> {{ task.idCase.status.title }}<br>
            <b>{{ $t('modals.finishedTaskDocument.idTaskType') }}:</b> {{ task.idTaskType.title }}<br>
            <b>{{ $t('modals.finishedTaskDocument.idDoneByUserData') }}:</b> {{ task.lastPoolTask.operationTransferUserData.name }} {{ task.lastPoolTask.operationTransferUserData.surname }}<br>
            <b>{{ $t('modals.finishedTaskDocument.idFinishByUserData') }}:</b> {{ task.idFinishByUserData.name }} {{ task.idFinishByUserData.surname }}<br>
            <b>{{ $t('modals.finishedTaskDocument.finishDate') }}:</b> {{ $moment(task.finishDate).format('YYYY-MM-DD HH:mm') }}
          </p>
        </b-col>
      </b-row>
      <template v-for="(documentPosition, documentPositionIndex) in document.positions">
        <Position v-bind:key="'documentPosition-' + documentPositionIndex"
                  :index="documentPositionIndex"
                  :itemsOptions="itemsOptions"
                  :removePosition="removePosition"
                  :item="documentPosition"></Position>
      </template>
      <b-row>
        <b-col>
          <b-btn @click="addNewPosition()">{{ $t('modals.finishedTaskDocument.addNewPosition') }}</b-btn>
          <b-btn @click="submitData()" variant="success">{{ $t('buttons.submit') }}</b-btn>
          <b-btn @click="cancelOperation()" variant="danger">{{ $t('buttons.cancel') }}</b-btn>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import Position from './Position'
import getId from '@/utils/getIdFromLink'
import { checkPermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'

export default {
  name: 'FinishedTaskDocument',
  components: {
    Position
  },
  computed: {
    ableToViewDocuments () {
      return checkPermission('warehouses', 'EXSBDocumentShow')
    }
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      document: {
        idTask: this.getIdLink(this.task['@id']),
        positions: []
      },
      itemsOptions: []
    }
  },

  created () {
    this.getItems()
  },

  methods: {
    getItems () {
      let idUserData = 0

      if (this.task.lastPoolTask.operation === 1) {
        idUserData = parseInt(this.getIdLink(this.task.lastPoolTask.operationUserData['@id']))
      } else if (this.task.lastPoolTask.operation === 2) {
        idUserData = parseInt(this.getIdLink(this.task.lastPoolTask.operationTransferUserData['@id']))
      }

      let params = {
        'pagination': false,
        'warehouse.userData': idUserData
      }
      this.$http
        .get('api/e_x_s_b_warehouse_items', {
          params
        })
        .then(response => {
          let array = []
          let warehouseItems = response.data['hydra:member']
          for (let i in warehouseItems) {
            if (warehouseItems[i].item) {
              array.push(warehouseItems[i].item)
            }
          }
          this.itemsOptions = array
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },

    async submitData () {
      let document = JSON.parse(JSON.stringify(this.document))
      if (document.idTask) {
        document.idTask = parseInt(this.getIdLink(document.idTask))
      }
      for (let i in document.positions) {
        if (document.positions[i].idExsbItem) {
          document.positions[i].idExsbItem = parseInt(this.getIdLink(document.positions[i].idExsbItem))
        }
      }
      const response = await new ApiService('e_x_s_b_documents/move_out').post(document)
      if (response.status < 300) {
        let newDocument = await response.json()
        if (this.ableToViewDocuments) this.$router.push({ name: 'EXSBDocumentShow', params: { id: newDocument['@id'] } })
        else this.$store.state.modals.finishedtaskdocument.create.close = 1
      }
    },

    cancelOperation () {
      this.$store.state.modals.finishedtaskdocument.create.close = 1
    },

    removePosition (index) {
      this.document.positions.splice(index, 1)
    },

    addNewPosition () {
      let item = {
        idExsbItem: null,
        quantity: 1
      }
      this.document.positions.push(item)
    },

    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
